export default __webpack_public_path__ + "static/media/live9.bf218bb6.jpeg";